export default "__VITE_PUBLIC_ASSET__7a430231__"